import HeaderDropdown from "./HeaderDropdown";
import Vs from "../assets/VsWhiteIcon.svg";

interface HeaderDropdownProps {
  team1Logo?: string;
  team2Logo?: string;
  onFirstTimerEnd?: () => void;
  onSecondTimerEnd?: () => void;
  onThirdTimerEnd?: () => void;
  selected?: number;
  startTime: number;
  startRound?: number;
}

function QuestionHeaderDropdown({
  team1Logo,
  team2Logo,
  onFirstTimerEnd,
  onSecondTimerEnd,
  onThirdTimerEnd,
  selected,
  startRound,
  startTime,
}: HeaderDropdownProps) {
  const handleFirstTimeEnd = () => {
    if (onFirstTimerEnd) {
      onFirstTimerEnd();
    }
  };

  const handleSecondTimeEnd = () => {
    if (onSecondTimerEnd) {
      onSecondTimerEnd();
    }
  };

  const handleThirdTimeEnd = () => {
    if (onThirdTimerEnd) {
      onThirdTimerEnd();
    }
  };

  return (
    <HeaderDropdown
      timer
      selected={selected}
      onFirstTimerEnd={handleFirstTimeEnd}
      onSecondTimerEnd={handleSecondTimeEnd}
      onThirdTimerEnd={handleThirdTimeEnd}
      startRound={startRound}
      startTime={Math.round(startTime / 1000)}
    >
      <div className="containerQuestionDropdownContent">
        <img
          src={team1Logo}
          alt=""
          className="containerQuestionDropdownTeamLogo"
        />
        <img src={Vs} alt="" className="containerQuestionDropdownVs" />
        <img
          src={team2Logo}
          alt=""
          className="containerQuestionDropdownTeamLogo"
        />
      </div>
    </HeaderDropdown>
  );
}

export default QuestionHeaderDropdown;
